import {
    IOrganization,
    IOrganizationSettingsCustomer,
} from "@/api/organizations/organizations.types";
import { ReactNode } from "react";
import { OrganizationContext } from "./OrganizationContext";

interface OrganizationProviderProps {
    children: ReactNode;
    organization: IOrganization;
    settings: IOrganizationSettingsCustomer;
    chatMaxDirectDocuments: number | undefined;
}

export function OrganizationProvider({
    children,
    organization,
    settings,
    chatMaxDirectDocuments,
}: OrganizationProviderProps) {
    return (
        <OrganizationContext.Provider
            value={{ organization, settings, chatMaxDirectDocuments }}
        >
            {children}
        </OrganizationContext.Provider>
    );
}
